/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ConnectFreeeForAccountingRequest
 */
export interface ConnectFreeeForAccountingRequest {
    /**
     * 口座の連携単位
     * @type {string}
     * @memberof ConnectFreeeForAccountingRequest
     */
    'walletableUnit': ConnectFreeeForAccountingRequestWalletableUnitEnum;
    /**
     * 連携開始日時(yyyy-MM-dd)
     * @type {string}
     * @memberof ConnectFreeeForAccountingRequest
     */
    'syncStartDate': string;
}

export const ConnectFreeeForAccountingRequestWalletableUnitEnum = {
    single: 'SINGLE',
    group: 'GROUP',
    all: 'ALL'
} as const;

export type ConnectFreeeForAccountingRequestWalletableUnitEnum = typeof ConnectFreeeForAccountingRequestWalletableUnitEnum[keyof typeof ConnectFreeeForAccountingRequestWalletableUnitEnum];


